import { faMobileAlt, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { faBuffer } from '@fortawesome/free-brands-svg-icons'

export const usefulLink = [
    {name: 'Home', id: 1},
    {name: 'About us', id: 2},
    {name: 'Services', id: 3},

]
export const ourServices = [
    {name: 'Custom Website Development', id: 6},
    {name: 'Ecommerce Stores', id: 7},
    {name: 'Brochure Websites', id: 8},
    {name: 'App Development', id: 9},
    {name: 'Cloud Architecture', id: 9},
    {name: 'Deployment & DevOps', id: 9},
    {name: 'Consulting', id: 10}
]
export const otherLinks = [
    {name: 'Support', id: 15},
]

export const footerInfo = [
    {icon: faBuffer, info1: 'MAHO Tech Solutions', id: 1},
    {icon: faMobileAlt, info1: '', info2: 'contact@mahotechsolutions.com.au', id: 2},
    {icon: faMapMarkedAlt, info1: 'Melbourne CBD', info2: 'Victoria Australia', id: 3}
];